module.exports = global.config = {
  settings: {
    //wsURL: "https://192.168.121.243:44376/",
    // rest of your translation object
    wsURL: "https://secure.kleerreg.com/",
  },
  // other global config variables you wish
};
